import { render } from "./BankDepositRecords.vue?vue&type=template&id=14c125ce&scoped=true"
import script from "./BankDepositRecords.vue?vue&type=script&lang=js"
export * from "./BankDepositRecords.vue?vue&type=script&lang=js"

import "./BankDepositRecords.vue?vue&type=style&index=0&id=14c125ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c125ce"]])

export default __exports__